var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInviteUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 48,
    viewBox: "0 0 59 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5708 27.8213C13.8942 27.8213 7.66016 21.5873 7.66016 13.9107C7.66016 6.23403 13.8942 0 21.5708 0C29.1959 0 35.3784 6.23403 35.3784 13.9107C35.3784 21.5873 29.1959 27.8213 21.5708 27.8213ZM21.5708 4.99753C16.6763 4.99753 12.6577 9.01616 12.6577 13.9107C12.6577 18.8051 16.6763 22.8238 21.5708 22.8238C26.4138 22.8238 30.3809 18.8051 30.3809 13.9107C30.3809 9.01616 26.4138 4.99753 21.5708 4.99753Z",
    fill: "#B08C3D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.427 47.9658C39.4481 47.9658 38.5208 47.3991 38.1086 46.4717C35.2749 39.8255 28.7318 35.4978 21.5189 35.4978C14.2544 35.4978 7.65972 39.774 4.82607 46.4717C4.25934 47.7597 2.81675 48.3265 1.52873 47.8113C0.240707 47.2445 -0.326023 45.802 0.189186 44.5139C3.84717 36.013 12.1936 30.5518 21.4673 30.5518C30.6896 30.5518 38.9844 36.0645 42.6424 44.5139C43.2092 45.802 42.5909 47.2445 41.3029 47.8113C41.0968 47.9143 40.7877 47.9658 40.427 47.9658Z",
    fill: "#B08C3D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1112 16.383H42.0753C40.6842 16.383 39.5508 15.2496 39.5508 13.8585C39.5508 12.4674 40.6842 11.334 42.0753 11.334H56.1112C57.5023 11.334 58.6358 12.4674 58.6358 13.8585C58.6358 15.3011 57.5023 16.383 56.1112 16.383Z",
    fill: "#B08C3D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M49.0421 23.3511C47.651 23.3511 46.5176 22.2176 46.5176 20.8266V6.89367C46.5176 5.5026 47.651 4.36914 49.0421 4.36914C50.4332 4.36914 51.5666 5.5026 51.5666 6.89367V20.8266C51.5151 22.2692 50.4332 23.3511 49.0421 23.3511Z",
    fill: "#B08C3D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInviteUserIcon);
export default __webpack_public_path__ + "static/media/invite-user-icon.6c2713252128ef100ac74deb8ec71bdc.svg";
export { ForwardRef as ReactComponent };